import { api } from 'data/api/api'

import { GetReferrerResp } from '../types/referrer'

export const getReferrer = () => api.get<GetReferrerResp>('/referrals/referrer')
